import { FilterMatchMode } from 'primeng/api';
import { FiltersAndSorts, NextSDRDateTypes, FilterDefinition, FILTER_TYPES, SortDefinition, SORT_MODES } from '@bds/next-sdr';
import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';

/**
 * Metodo per la creazione di filtri compatibili con NextSdr
 * @param event l'evento di lazy loading della tabella
 * @param columns
 * @param datepipe
 */
function buildLazyEventFiltersAndSorts(event, columns, datepipe) {
  const lazyEventFiltersAndSorts = new FiltersAndSorts();
  if (event) {
    if (event.filters) {
      const keys = Object.keys(event.filters);
      for (const key of keys) {
        // la variabile indica se nessuna trasformazione è stata usata e quindi il filtro deve essere applicato direttamente
        let noTrasformationUsed = true;
        const filterColumn = columns.find(currCol => (currCol.filterField ? currCol.filterField : currCol.field) === key);
        const filterMetadata = event.filters[key];
        if (filterMetadata.value != undefined && filterMetadata.value != null) {
          if (filterColumn) {
            // trasformazioni per i filtri di tipo data
            if (filterColumn.fieldType === "Date" || filterColumn.fieldType === "DateTime" || filterColumn.fieldType === NextSDRDateTypes.ZonedDateTime || filterColumn.fieldType === NextSDRDateTypes.LocalDateTime || filterColumn.fieldType === NextSDRDateTypes.LocalDate) {
              let pattern = null; //filterColumn.fieldType === "Date" ? "yyyy-MM-ddT00:00:00" : "yyyy-MM-ddTHH:mm:ss.SSSSSS";
              switch (filterColumn.fieldType) {
                case "Date":
                  pattern = "yyyy-MM-ddT00:00:00";
                  break;
                case "DateTime":
                  pattern = "yyyy-MM-ddTHH:mm:ss.SSSSSS";
                  break;
                case NextSDRDateTypes.ZonedDateTime:
                  pattern = "yyyy-MM-dd'T'HH:mm:ss.SSSSSSZZZZZ";
                  break;
                case NextSDRDateTypes.LocalDateTime:
                  pattern = "yyyy-MM-dd'T'HH:mm:ss.SSSSSS";
                  break;
                case NextSDRDateTypes.LocalDate:
                  pattern = "yyyy-MM-dd";
                  break;
              }
              filterMetadata.value.forEach(element => {
                /* TODO: nella definizione dell'entità sul back-end.*/
                if (element) {
                  lazyEventFiltersAndSorts.addFilter(new FilterDefinition(key, filterColumn.filterMatchMode, datepipe.transform(element, pattern) /* .replace("+", "%2b") + "%5BEurope%2FBerlin%5D"*/));
                }
              });
              noTrasformationUsed = false;
            }
          }
          if (noTrasformationUsed) {
            if (key === "global") {
              // Questo è il filtro globale di una tabella. Dentro il value trovo cosa sta cercando l'utente. La colonna su cui cerco è sempre "tscol"
              lazyEventFiltersAndSorts.addFilter(new FilterDefinition("tscol", FILTER_TYPES.not_string.equals, event.filters[key].value));
              if (!event.sortField) {
                // Se non c'è una richiesta di ordinamento allora ordino per il ranking, la colonna per cui ordino è sempre "ranking"
                lazyEventFiltersAndSorts.addSort(new SortDefinition("ranking", SORT_MODES.desc));
              }
            } else if (filterMetadata.matchMode === FilterMatchMode.IN) {
              if (filterMetadata.value != undefined && filterMetadata.value != null) {
                filterMetadata.value.forEach(val => {
                  lazyEventFiltersAndSorts.addFilter(new FilterDefinition(key, filterColumn && filterColumn.useFilterMatchMode ? filterColumn.filterMatchMode : FILTER_TYPES.not_string.equals,
                  // Metto equals di default nel caso non ci sia la filterColumn.
                  val));
                });
              }
            } else {
              lazyEventFiltersAndSorts.addFilter(new FilterDefinition(key, filterColumn && filterColumn.useFilterMatchMode ? filterColumn.filterMatchMode : filterMetadata.matchMode, event.filters[key].value));
              if (!event.sortField && filterColumn && filterColumn.autoSortingField) {
                // Se non c'è una richiesta di ordinamento e la colonna filtrata vuole l'autosorting allora lo faccio
                lazyEventFiltersAndSorts.addSort(new SortDefinition(filterColumn.autoSortingField, SORT_MODES.desc));
              }
            }
          }
        }
      }
    }
    if (event.sortField) {
      const sortColumn = columns.find(currCol => (currCol.sortField ? currCol.sortField : currCol.field) === event.sortField);
      if (sortColumn.sortField && typeof sortColumn.sortField === "object") {
        sortColumn.sortField.forEach(element => {
          lazyEventFiltersAndSorts.addSort(new SortDefinition(element, event.sortOrder === 1 ? SORT_MODES.asc : SORT_MODES.desc));
        });
      } else {
        lazyEventFiltersAndSorts.addSort(new SortDefinition(event.sortField, event.sortOrder === 1 ? SORT_MODES.asc : SORT_MODES.desc));
      }
      // se è un campo calcolato potrebbe essere composto da più subfields e tutti questi concorrono nell'ordinamento
      // queste informazioni le prendo dalle columns che vengono passate dal componente dell'applicazione
      /* if (sortColumn.campoCalcolato === true) {
          sortColumn.subfields.array.forEach(element => {
              lazyEventFiltersAndSorts.addSort(new SortDefinition(element, event.sortOrder === 1 ?
                  SORT_MODES.asc : SORT_MODES.desc));
          });
      
      } else {
          // per ora gestiamo solo il caso di un solo filtro (widget importati con ordinamento singolo)
          lazyEventFiltersAndSorts.addSort(new SortDefinition(event.sortField, event.sortOrder === 1 ?
              SORT_MODES.asc : SORT_MODES.desc));
      }*/
    }
    //     lazyEventFiltersAndSorts.first = event.first;
    //    lazyEventFiltersAndSorts.rows = event.rows;
  }
  return lazyEventFiltersAndSorts;
}
function buildPagingConf(event, limitOffsetMode = false) {
  if (event) {
    if (limitOffsetMode) {
      return {
        mode: "LIMIT_OFFSET",
        conf: {
          limit: event.rows,
          offset: event.first
        }
      };
    } else {
      return {
        mode: "PAGE",
        conf: {
          page: event.first / event.rows,
          size: event.rows
        }
      };
    }
  } else {
    return {
      mode: "NONE"
    };
  }
}

/* import { ConfirmDialogModule } from "primeng/confirmdialog"; */
class PrimengPluginModule {
  /** @nocollapse */static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: PrimengPluginModule,
    deps: [],
    target: i0.ɵɵFactoryTarget.NgModule
  });
  /** @nocollapse */
  static ɵmod = i0.ɵɵngDeclareNgModule({
    minVersion: "14.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: PrimengPluginModule
  });
  /** @nocollapse */
  static ɵinj = i0.ɵɵngDeclareInjector({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: PrimengPluginModule
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: PrimengPluginModule,
  decorators: [{
    type: NgModule,
    args: [{
      imports: [],
      providers: []
    }]
  }]
});

/*
 * Public API Surface of primeng-plugin
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PrimengPluginModule, buildLazyEventFiltersAndSorts, buildPagingConf };
